<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 13:27:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-12 09:14:25
 * @FilePath: /wemeet-admin-new/src/views/data/components/questionaireAnalysis.vue
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
-->
<template>
  <div class="dialogCard" style="margin-top: 20px; width: 100%">
    <div class="subBox">
      <div>
        <div class="title">
          <span>问卷统计</span>
          <!-- <el-tooltip
            effect="dark"
            content="用户访问人数、报名、签到等关键数据，连续多天的趋势"
            placement="top-start"
          >
            <img
              src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/tips.png"
              alt=""
              class="tipsIcon"
            />
          </el-tooltip> -->
        </div>
        <div class="subTitle">更新时间：{{ nowTime }}</div>
      </div>
      <div class="chooseTime">
        <span class="timeLabel">筛选条件</span>
        <el-select v-model="value" placeholder="注册身份" size="large" style="width: 240px" @change="changeIdentity">
          <el-option v-for="item in option" :key="item.identity" :label="item.name" :value="item.identity" />
        </el-select>
      </div>
    </div>

    <el-row>
      <el-col v-for="(item, index) in questionnaire" :key="index" :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
        <div class="tableData">
          <div class="question">
            {{ item.formType == 'CHECKBOX' ? '多选题' : '单选题' }}
            {{ item.formTitle }}
          </div>

          <el-table :data="item.details" style="width: 100%; margin-top: 10px">
            <el-table-column label="选项" prop="formContent" />
            <el-table-column label="小计" prop="count" />
            <el-table-column label="比例">
              <template #default="{ row }">
                <el-progress :percentage="row.proportion" />
              </template>
            </el-table-column>

            <template #empty>
              <noDataVue />
            </template>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'
  import noDataVue from './noData.vue'

  export default defineComponent({
    components: {
      VabChart,
      VabCount,
      noDataVue,
    },
    props: {
      idenityCount: {
        type: Array,
        default: [],
      },
      questionnaire: {
        type: Object,
        default: {},
      },
      nowTime: {
        type: String,
        default: '',
      },
      defaultIdentity: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      watch(
        () => props.idenityCount,
        (nval, oval) => {
          state.option = nval
          const def = nval.find((e) => e.identity === props.defaultIdentity) || nval?.[0]
          if (def.identity && state.value !== def.identity) {
            state.value = def.identity || ''
            changeIdentity()
          }
        },
        {
          deep: true,
        }
      )
      const state = reactive({
        option: [],
        value: '',
        shortcuts: [
          {
            text: '上一周',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 7)
              return [start, end]
            },
          },
          {
            text: '上个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 1)
              return [start, end]
            },
          },
          {
            text: '前三个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 3)
              return [start, end]
            },
          },
        ],
        tableData: [],
      })

      window.onresize = () => {
        console.log(`resize`)
      }

      const changeIdentity = () => {
        console.log(state.value)
        emit('identityChangeQuestion', state.value)
      }
      return {
        ...toRefs(state),
        changeIdentity,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;

    .subBox {
      display: flex;
      justify-content: space-between;

      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
        display: flex;
        align-items: center;

        .tipsIcon {
          width: 18px;
          height: 18px;
          margin-left: 8px;
        }
      }

      .subTitle {
        font-size: 12px;
        color: #4e5969;
      }

      .chooseTime {
        .timeLabel {
          font-size: 14px;
          color: #4e5969;
          margin-right: 16px;
        }
      }
    }

    .tableData {
      width: 100%;

      .question {
        font-size: 14px;
        color: #1d2129;
        margin-top: 20px;
      }
    }
  }
</style>
